import { render } from "./GlobalModal.vue?vue&type=template&id=3932a4bb"
import script from "./GlobalModal.vue?vue&type=script&lang=js"
export * from "./GlobalModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__